import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getAiVisCssVars } from '../pages/ai-vis/aivisTheme';
import '../pages/ai-vis/ai-vis.css';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="aivis-auth-page" style={getAiVisCssVars()}>
        <div className="aivis-loading-screen" role="status" aria-live="polite">
          <div className="aivis-loading-dot" />
          <span>Loading…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/ai-vis/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
